import { lotCodeType } from "../type";

const initialState = {
  lotCodeDiamond: undefined,
  lotCodePrecious: undefined,
  lotCodeInsert: undefined,
  lotCodeSemiPrecious: undefined,
  lotCodeChain: undefined,
  lotCodeFinding: undefined,
  RawMaterialSuid:undefined,
  error: undefined,
  isLoading: false,
  validLotCode:undefined,
  message: undefined,
};

const lotCodeReducer = (state = initialState, action) => {
  const { type, payload = {}, RawMaterialSuid } = action;
  
  const { message } = payload;

  switch (type) {
    case lotCodeType.PRICE_CHART_LOTCODE_LIST:
      return {
        ...state,
        isLoading: false,
        message,
        error: undefined,
        data: payload,
      };
    case lotCodeType.PRICE_CHART_LOTCODE_DIAMOND:
      return {
        ...state,
        isLoading: false,
        message,
        error: undefined,
        lotCodeDiamond: payload,
      };
    case lotCodeType.PRICE_CHART_LOTCODE_PRECIOUS:
      return {
        ...state,
        isLoading: false,
        message,
        error: undefined,
        lotCodePrecious: payload,
      };
    case lotCodeType.PRICE_CHART_LOTCODE_SEMI_PRECIOUS:
      return {
        ...state,
        isLoading: false,
        message,
        error: undefined,
        lotCodeSemiPrecious: payload,
      };
    case lotCodeType.PRICE_CHART_LOTCODE_CHAIN:
      return {
        ...state,
        isLoading: false,
        message,
        error: undefined,
        lotCodeChain: payload,
      };
    case lotCodeType.PRICE_CHART_LOTCODE_FINDING:
      return {
        ...state,
        isLoading: false,
        message,
        error: undefined,
        lotCodeFinding: payload,
      };
    case lotCodeType.PRICE_CHART_LOTCODE_INSERT:
      return {
        ...state,
        isLoading: false,
        message,
        error: undefined,
        lotCodeInsert: payload,
        RawMaterialSuid:RawMaterialSuid,
       
      };
    case lotCodeType.PRICING_CHART_ERROR:
      return {
        ...state,
        isLoading: false,
        error: payload,
      };
    default:
      return state;
  }
};
export default lotCodeReducer;
